/* eslint-disable import/prefer-default-export */

export { default as ClientAPI } from './services/ClientAPI';



// WEBPACK FOOTER //
// ./node_modules/@adactive/adsum-utils/index.js